import icons from "../../assets/images/sprite-other-icons.svg";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import { useDispatch, useSelector } from "react-redux";
import { handleLogout } from "../changePin/cl_ChangePinSlice";
import Wallet from "../../assets/images/wallet .svg";
import BonusGift from "../../assets/images/bonus.svg";
import Coin from "../../assets/images/coin.svg";
import { setIsSideMenuOpened } from "../signUp/cl_SignUpSlice";
import { getUserDetails, getUserLoyalty } from "../signIn/cl_SignInSlice";
import LoyaltyConfig from "../../assets/loyaltyPointsConfig.json";
import { RedeemModal } from "../fasfasCoins/RedeemModal";
import { setIsmodalOpen, setShowRedeemPopUp } from "../home/cl_LoyalltyCoins";

function SideMenuBar({ setIsMenuOpen, isMenuOpen, buttonRef, onOpenLottery }) {
  const [IsOpen, setIsOpen] = useState(false);
  const [IsBonusDropDownOpen, setIsBonusDropDownOpen] = useState(false);
  const [balDropDown, setBalDropDown] = useState(false);
  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const { balance, userDetails, balanceDetails, userLoyalty } = useSelector(
    (state) => state?.signIn
  );
  // console.log("userLoyalty: ", userLoyalty?.level);
  const menuRef = useRef(null);
  const [bonusAccordion, setBonusAccordion] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = getFromLocalStorage("gk");

  const navigateTo = (route) => {
    dispatch(setIsSideMenuOpened(false));
    navigate(`/${route}`);
  };

  const logout = () => {
    dispatch(handleLogout(token, navigate));
    dispatch(setIsSideMenuOpened(false));
    dispatch(setIsmodalOpen(false));
  };
  const dropdownOpen = () => {
    setIsOpen(!IsOpen);
  };
  const handleBonusdropDown = () => {
    setIsBonusDropDownOpen(!IsBonusDropDownOpen);
  };

  const freeGamesCount = balanceDetails?.bonus_summary?.result?.data?.freeSpinCount;

  useEffect(() => {
    if (userDetails?.userId) {
      //dispatch(getUserLoyalty(userDetails?.userId))
    }
  }, [userDetails?.userId]);
  const handleClickOutside = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      !buttonRef.current.contains(event.target)
    ) {
      setIsMenuOpen(false);
      dispatch(setIsSideMenuOpened(false));
    }
  };

  const redeemCoin = () => {
    let errorMsg = "";

    if (!burnCoins || burnCoins > userLoyalty.coins) {
      const currentLevel =
        LoyaltyConfig.loyaltyPointsConfig[1]?.loyaltyLevels.find(
          (data) => userLoyalty.level === data.level
        );

      if (currentLevel) {
        const maxCoins =
          currentLevel.level === "level4"
            ? userLoyalty?.coins
              ? Math.floor(userLoyalty?.coins)
              : 0
            : currentLevel.maxBurnCoins;

        errorMsg = `Please enter value less than ${maxCoins} coins`;
      }
    } else {
      LoyaltyConfig.loyaltyPointsConfig[1]?.loyaltyLevels.forEach((data) => {
        if (userLoyalty.level === data.level) {
          if (data?.level === "level4") {
            setMinMaxValue(
              `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0
              } Coins)`
            );
          } else {
            setMinMaxValue(
              `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${Number(data.maxBurnCoins).toLocaleString()} Coins)`
            );
          }
          if (data.level === "level4") {
            if (burnCoins < data.minBurnCoins) {
              errorMsg = `Please enter a value greater than ${data.minBurnCoins - 1
                } coins`;
            } else if (burnCoins > userLoyalty?.coins) {
              errorMsg = `Please enter a value less than ${userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0
                } coins`;
            }
          } else if (burnCoins < data.minBurnCoins) {
            errorMsg = `Please enter a value greater than ${data.minBurnCoins - 1
              } coins`;
          } else if (burnCoins > data.maxBurnCoins) {
            errorMsg = `Please enter a value less than ${data.maxBurnCoins + 1
              } coins`;
          }
        }
      });
    }
    if (errorMsg) {
      dispatch(setShowRedeemPopUp(false));
    } else {
      setShowRedeemModal(false);
      dispatch(setShowRedeemPopUp(true));
    }
    setErrorMessage(errorMsg);
  };

  useEffect(() => {
    LoyaltyConfig.loyaltyPointsConfig[1]?.loyaltyLevels.forEach((data) => {
      if (userLoyalty?.level === data?.level) {
        if (data?.level === "level4") {
          setMinMaxValue(
            `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${userLoyalty?.coins ? Math.floor(userLoyalty?.coins).toLocaleString() : 0
            } Coins)`
          );
        } else {
          setMinMaxValue(
            `(Min ${Number(data.minBurnCoins).toLocaleString()} Coins - Max ${Number(data.maxBurnCoins).toLocaleString()} Coins)`
          );
        }
        setPerMinMaxValue(
          data?.levelCutoff ? data?.levelCutoff : data?.levelEntry
        );
      }
    });
  }, [userLoyalty?.level, userLoyalty?.coins]);

  const balenceCoins = userLoyalty?.coins > 0 ? userLoyalty?.coins : 0;
  const { coinsHistoryData } = useSelector((state) => state.coinsHistory);
  const filteredData =
    coinsHistoryData &&
    coinsHistoryData?.filter((item) => item.loyaltyType === "burn");
  const levelIndex = parseInt(userLoyalty?.level?.replace("level", ""));
  const minBurnCoins =
    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[levelIndex]
      ?.minBurnCoins;
  const [minMaxValues, setMinMaxValue] = useState("");

  const { isModalOpen, showRedeemPopUp } = useSelector(
    (state) => state?.coinsHistory
  );
  const [perMaxValues, setPerMinMaxValue] = useState("");
  const [burnCoins, setBurnCoins] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const handleChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[+-]+/, "");
    const re = /^[0-9]*$/;
    if (re.test(inputValue)) {
      setBurnCoins(inputValue);
    }

    setErrorMessage("");
  };
  const handleKeyDown = (e) => {
    if (e.key === "+" || e.key === "-") {
      e.preventDefault();
    }
  };

  useEffect(() => {
    dispatch(getUserDetails());
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);
  return (
    <React.Fragment>
      {isMenuOpen && (
        <div className="SB-dropdown-menu" ref={menuRef}>
          <div id="page-header-myAccountMenu">
            <div className="SB-myAccountMenu-container">
              <div className="SB-myAccountMenu-close-container">
                <div
                  className="SB-myAccountMenu-closeButton"
                  id="SB-myAccountMenu-closeButton"
                  onClick={() => {
                    setIsMenuOpen(false);
                    dispatch(setIsSideMenuOpened(false));
                  }}
                >
                  Close
                  <div className="SB-iconSVG">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#${"icon-close"}`} />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="SB-myAccountBalance-container">
                <div className="SB-userMobileNumber d-none">
                  <b id="userPhoneNumber">
                    {userDetails?.userOtherInfo?.phone}
                  </b>
                </div>
                <div className="SB-userProfile">
                  <div className="SB-usericon">
                    <div className="SB-icon-container">
                      <div className="SB-iconSVG" title="user">
                        {userLoyalty?.lifeTimeCoins <=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                            .levelCutoff ? (
                          <img
                            src={require("../../assets/images/loyalty/dash.webp")}
                            alt="dash"
                          />
                        ) : userLoyalty?.lifeTimeCoins <=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                            .levelCutoff ? (
                          <img
                            src={require("../../assets/images/loyalty/sprint.webp")}
                            alt="sprint"
                          />
                        ) : userLoyalty?.lifeTimeCoins <=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                            .levelCutoff ? (
                          <img
                            src={require("../../assets/images/loyalty/surge.webp")}
                            alt="surge"
                          />
                        ) : userLoyalty?.lifeTimeCoins <=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                            .levelEntry ? (
                          <img
                            src={require("../../assets/images/loyalty/thrill.webp")}
                            alt="thrill"
                          />
                        ) : userLoyalty?.lifeTimeCoins >=
                          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                            .levelEntry ? (
                          <img
                            src={require("../../assets/images/loyalty/boss.webp")}
                            alt="boss"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="SB-userDetails">
                    <div className="SB-userName d-none">
                      {userDetails?.userName}
                    </div>
                    <div className="SB-userNumber">
                      {userDetails?.userOtherInfo?.phone}
                    </div>
                  </div>
                </div>

                <div
                  className={`SB-accordion SB-userBalanceSection ${balDropDown ? "" : "collapsed"
                    }`}
                >
                  <div
                    className="SB-accordion-header SB-arrowAfter"
                    onClick={() => setBalDropDown(!balDropDown)}
                  >
                    <div className="SB-contentBlock">
                      <div className="SB-leftContent">
                        <div className="SB-balanceLabel">Cash Balance</div>
                      </div>
                      <div className="SB-rightContent">
                        <div className="SB-userBalance SB-txtHighlight">
                          <img src={Wallet} alt="wallet" />
                          <b id="userBalanceAmount">
                            KES {balanceDetails?.real_balance?.result?.balance.toLocaleString()}
                          </b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="SB-accordion-content">
                    <div className="SB-contentBlock">
                      <div className="SB-leftContent">
                        <div className="SB-balanceLabel">
                          Withdrawable Balance
                        </div>
                      </div>
                      <div className="SB-rightContent">
                        <div className="SB-userBalance">
                          KES {balanceDetails?.real_balance?.result?.withdrawls.toLocaleString()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="SB-accordion SB-userBalanceSection collapsed d-none">
                  <div
                    className="SB-accordion-header SB-arrowAfter"
                    onClick={dropdownOpen}
                  ></div>
                </div>

                {/* <div className='SB-userBonusSection'> */}
                <div
                  className={`SB-accordion SB-casinoBonusBlock ${bonusAccordion ? "" : "collapsed"
                    }`}
                  onClick={() => setBonusAccordion(!bonusAccordion)}
                >
                  <div className="SB-accordion-header SB-arrowAfter">
                    <div className="SB-contentBlock">
                      <div className="SB-leftContent">Bonus</div>
                      <div className="SB-rightContent" id="unLockedBonus">
                        <img src={BonusGift} alt="bonus" />{" "}
                        {
                          balanceDetails?.bonus_summary?.result?.data
                            ?.lockedBonus
                        }
                      </div>
                    </div>
                  </div>
                  <div className="SB-accordion-content">
                    <div className="SB-contentBlock">
                      <div className="SB-leftContent">Games locked Bonus</div>
                      <div className="SB-rightContent" id="casinoLockedBonus">
                        {
                          balanceDetails?.bonus_summary?.result?.data
                            ?.lockedBonus
                        }
                      </div>
                    </div>
                    {/* <div className="SB-contentBlock">
                      <div className="SB-leftContent">Games unlocked Bonus</div>
                      <div className="SB-rightContent" id="casinoUnLockedBonus">
                        {
                          balanceDetails?.bonus_summary?.result?.data
                            ?.unLockedBonus
                        }
                      </div>
                    </div> */}
                  </div>
                </div>
                {/* </div> */}
                <div className="SB-userCoinsBalance">
                  <div className="SB-coinsItem SB-coinsBalance">
                    <div className="SB-coinsItem-label">
                      FasFas Coins Balance
                    </div>
                    <div className="SB-redeemCoins">
                      <div className="SB-btnContainer">
                        {userLoyalty?.coins
                          ? Math.floor(userLoyalty?.coins) >= minBurnCoins && (
                            <button
                              className="btn SB-btnSecondary active SB-btnredeem"
                              onClick={() => setShowRedeemModal(true)}
                            >
                              Redeem
                            </button>
                          )
                          : ""}
                      </div>
                      <div className="SB-coinsItem-value">
                        <img src={Coin} alt="coin" />
                        <span>
                          {userLoyalty?.coins
                            ? Math.floor(userLoyalty?.coins).toLocaleString()
                            : 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="SB-userCoinsBalance">
                  <div className="SB-coinsItem SB-coinsBalance">
                    <div className="SB-coinsItem-label">Free Game Count</div>
                    <div className="SB-redeemCoins">
                      <div className="SB-coinsItem-value">
                        <span>
                          {freeGamesCount
                            ? Math.floor(freeGamesCount)
                            : 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {showRedeemModal && userLoyalty?.coins ? (
                  Math.floor(userLoyalty?.coins) >= minBurnCoins ? (
                    <div className="SB-modal SB-modal-fullscreen SB-burnCoins-modal open">
                      <div className="SB-modal-dialog">
                        <div className="SB-modal-content">
                          <div
                            className="SB-modal-close"
                            onClick={() => {
                              setShowRedeemModal(false);
                              setBurnCoins("");
                              setErrorMessage("");
                            }}
                          >
                            <div className="SB-iconSVG" title="close">
                              <svg xmlns="http://www.w3.org/2000/svg">
                                <use xlinkHref={`${icons}#icon-close`} />
                              </svg>
                            </div>
                          </div>
                          <div className="SB-modal-body">
                            <div className="SB-myAccount-sectionBox SB-burnCoins">
                              <div className="SB-myAccount-sectionBox_content">
                                <p className="SB-burnCoins-text SB-title">
                                  You can burn Fasfas Coins now for an exchange
                                  of surprise Instant Cash
                                </p>
                                <div className="SB-form-group">
                                  <div className="SB-form-label">
                                    <span>Enter Fasfas Coins to burn</span>
                                    <span className="SB-coinsMinMax">
                                      {minMaxValues}
                                    </span>
                                  </div>
                                  <div className="SB-form-control">
                                    <input
                                      type="text"
                                      value={burnCoins}
                                      onChange={handleChange}
                                      onKeyDown={handleKeyDown}
                                      placeholder="Enter Coins Here"
                                      maxLength={10}
                                    />
                                  </div>
                                  <div className="SB-form-errorMsg">
                                    {errorMessage && (
                                      <span>{errorMessage}</span>
                                    )}
                                  </div>
                                </div>
                                <div className="SB-btnContainer">
                                  <button
                                    className="btn SB-btnSecondary active SB-btncoinsBurnNow"
                                    data-toggle="modal"
                                    data-target="SB-burnNowCoins-modal"
                                    onClick={redeemCoin}
                                  >
                                    Burn Now
                                  </button>
                                </div>
                                <p className="SB-burnCoins-text SB-instantCash">
                                  You will get Instant Cashback credited to your
                                  wallet immediately
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {showRedeemPopUp && (
                  <RedeemModal coins={burnCoins} setBurnCoins={setBurnCoins} />
                )}

                <div className="SB-btnContainer">
                  <button
                    className="btn SB-btnSecondary SB-btnMedium active SB-btnDepositMyAccount"
                    onClick={() => navigateTo("deposit")}
                  >
                    Deposit
                  </button>
                  <button
                    className="btn SB-btnSecondary SB-btnMedium active SB-btnWithdrawMyAccount"
                    onClick={() => navigateTo("withdraw")}
                  >
                    Withdraw
                  </button>
                </div>
              </div>

              <div className="SB-myAccountLinks-container">
                <div className="SB-myAccount-highlightList">
                  <ul>
                    <li>
                      <div
                        className="SB-myAccount-highlightList-item"
                        onClick={() => navigateTo("loyalty")}
                      >
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-loyalty"}`} />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Loyalty
                        </div>
                      </div>
                    </li>
                    <li className="d-none">
                      <div className="SB-myAccount-highlightList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG" title="leaderboard">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-leaderboard"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          LeaderBoard
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        className="SB-myAccount-highlightList-item"
                        onClick={() => navigateTo("fasfascoins")}
                      >
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG" title="coins">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-coins"}`} />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Coins
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="SB-myAccountList">
                  <ul>
                    <li
                      onClick={() => navigateTo("about")}
                      className="aboutusItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="aboutus">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-aboutus"}`} />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          About Us
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li
                      onClick={() => {
                        if (onOpenLottery) onOpenLottery();
                        setIsMenuOpen(false);
                        dispatch(setIsSideMenuOpened(false));
                      }}
                      className="aboutusItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="aboutus">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_6185_22194)">
                                <path d="M7.91722 6.80449V5.19616C7.90369 5.07053 7.93962 4.94457 8.01742 4.84501C8.09522 4.74543 8.20875 4.68009 8.33389 4.66283V4.12533C8.20835 4.10708 8.09482 4.04087 8.01715 3.94063C7.93942 3.84039 7.90362 3.71393 7.91722 3.58783V2.78783C7.92015 2.74723 7.92575 2.70687 7.93389 2.66699H1.25057C0.919348 2.66798 0.601982 2.79999 0.367776 3.0342C0.13357 3.26841 0.00155574 3.58578 0.000566538 3.91699V4.32949C-0.00122084 4.45991 0.0276321 4.58894 0.0848036 4.70617C0.141975 4.82341 0.225868 4.92559 0.329733 5.00449C0.486046 5.11926 0.613146 5.26921 0.700755 5.44221C0.788355 5.61521 0.834008 5.80641 0.834008 6.00033C0.834008 6.19425 0.788355 6.38544 0.700755 6.55844C0.613146 6.73145 0.486046 6.88139 0.329733 6.99616C0.225868 7.07506 0.141975 7.17724 0.0848036 7.29448C0.0276321 7.41171 -0.00122084 7.54074 0.000566538 7.67116V8.08366C0.00155574 8.41487 0.13357 8.73225 0.367776 8.96645C0.601982 9.20066 0.919348 9.33267 1.25057 9.33366H7.93389C7.92575 9.29379 7.92015 9.25342 7.91722 9.21283V8.41283C7.90362 8.28673 7.93942 8.16026 8.01715 8.06002C8.09482 7.95978 8.20835 7.89357 8.33389 7.87533V7.33783C8.20875 7.32057 8.09522 7.25522 8.01742 7.15564C7.93962 7.05608 7.90369 6.93012 7.91722 6.80449ZM5.8339 7.25033H3.3339C3.22339 7.25033 3.11741 7.20643 3.03927 7.12828C2.96113 7.05015 2.91723 6.94417 2.91723 6.83366C2.91723 6.72315 2.96113 6.61717 3.03927 6.53903C3.11741 6.46089 3.22339 6.41699 3.3339 6.41699H5.8339C5.94441 6.41699 6.05039 6.46089 6.12853 6.53903C6.20667 6.61717 6.25057 6.72315 6.25057 6.83366C6.25057 6.94417 6.20667 7.05015 6.12853 7.12828C6.05039 7.20643 5.94441 7.25033 5.8339 7.25033ZM5.8339 5.58366H3.3339C3.22339 5.58366 3.11741 5.53976 3.03927 5.46162C2.96113 5.38348 2.91723 5.2775 2.91723 5.16699C2.91723 5.05649 2.96113 4.95051 3.03927 4.87237C3.11741 4.79423 3.22339 4.75033 3.3339 4.75033H5.8339C5.94441 4.75033 6.05039 4.79423 6.12853 4.87237C6.20667 4.95051 6.25057 5.05649 6.25057 5.16699C6.25057 5.2775 6.20667 5.38348 6.12853 5.46162C6.05039 5.53976 5.94441 5.58366 5.8339 5.58366Z" fill="white" />
                                <path d="M8.75114 8.41283V9.21283C8.74821 9.25342 8.74267 9.29379 8.73447 9.33366H10.4178C10.749 9.33267 11.0664 9.20066 11.3006 8.96645C11.5348 8.73225 11.6668 8.41487 11.6678 8.08366V7.67116C11.6696 7.54074 11.6407 7.41171 11.5836 7.29448C11.5264 7.17724 11.4425 7.07506 11.3387 6.99616C11.1823 6.88139 11.0553 6.73145 10.9676 6.55844C10.88 6.38544 10.8344 6.19425 10.8344 6.00033C10.8344 5.80641 10.88 5.61521 10.9676 5.44221C11.0553 5.26921 11.1823 5.11926 11.3387 5.00449C11.4425 4.92559 11.5264 4.82341 11.5836 4.70617C11.6407 4.58894 11.6696 4.45991 11.6678 4.32949V3.91699C11.6668 3.58578 11.5348 3.26841 11.3006 3.0342C11.0664 2.79999 10.749 2.66798 10.4178 2.66699H8.73447C8.74267 2.70687 8.74821 2.74723 8.75114 2.78783V3.58783C8.76474 3.71393 8.72894 3.84039 8.65127 3.94063C8.57354 4.04087 8.46001 4.10708 8.33447 4.12533V4.66283C8.45967 4.68009 8.57321 4.74543 8.65094 4.84501C8.72874 4.94457 8.76467 5.07053 8.75114 5.19616V6.80449C8.76467 6.93012 8.72874 7.05608 8.65094 7.15564C8.57321 7.25522 8.45967 7.32057 8.33447 7.33783V7.87533C8.46001 7.89357 8.57354 7.95978 8.65127 8.06002C8.72894 8.16026 8.76474 8.28673 8.75114 8.41283Z" fill="white" />
                              </g>
                              <defs>
                                <clipPath id="clip0_6185_22194">
                                  <rect width="12" height="12" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>

                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Lottery
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li
                      onClick={() => navigateTo("bethistory")}
                      className="betHistoryItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Bet history">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-bet-history"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Game History
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      className="coinsHistoryItem"
                      onClick={() => navigateTo("coins-history")}
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="loyalty">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-coins-history"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          FasFas Coins History
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG" title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      onClick={() => navigateTo("accounthistory")}
                      className="accountHistoryItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Account History">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-account-history"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          className="SB-myAccountList-item-content"
                          onClick={() => navigateTo("accounthistory")}
                        >
                          Account History
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      onClick={() => navigateTo("mybonuses")}
                      className="accountHistoryItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Account History">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-bonus"}`} />
                            </svg>
                          </div>
                        </div>
                        <div
                          className="SB-myAccountList-item-content"
                          onClick={() => navigateTo("mybonuses")}
                        >
                          My Bonuses
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li className="bonusUsageItem d-none">
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Bonus History">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref="images/sprite-other-icons.svg#icon-bonus"></use>
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Bonus Usage
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      onClick={() => navigateTo("profile")}
                      className="accountDetailsItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Account Details">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-account-details"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Profile
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    {userLoyalty?.level === "level4" ? null : (
                      <li
                        className="referAndEarn"
                        onClick={() => navigateTo("refer")}
                      >
                        <div className="SB-myAccountList-item">
                          <div className="SB-icon-container">
                            <div className="SB-iconSVG " title="Refer A Friend">
                              <svg xmlns="http://www.w3.org/2000/svg">
                                <use
                                  xlinkHref={`${icons}#${"icon-referAFriend"}`}
                                />
                              </svg>
                            </div>
                          </div>

                          <div className="SB-myAccountList-item-content">
                            Refer and Earn
                          </div>

                          <div className="SB-arrow-container">
                            <div className="SB-iconSVG " title="Arrow Right">
                              <svg xmlns="http://www.w3.org/2000/svg">
                                <use
                                  xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </li>
                    )}

                    <li
                      className="changePinItem"
                      onClick={() => navigateTo("change-pin")}
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG" title="Change PIN">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-change-pin"}`}
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Change PIN
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li
                      onClick={() => navigateTo("selfexclusion")}
                      className="accountDetailsItem"
                    >
                      <div className="SB-myAccountList-item">
                        <div className="SB-icon-container">
                          <div className="SB-iconSVG " title="Account Details">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-info"}`} />
                            </svg>
                          </div>
                        </div>
                        <div className="SB-myAccountList-item-content">
                          Responsible Gambling
                        </div>
                        <div className="SB-arrow-container">
                          <div className="SB-iconSVG " title="Arrow Right">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use
                                xlinkHref={`${icons}#${"icon-angle-arrow-right"}`}
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="">
                <a href="edit-account.html">
                  <button
                    className="btn SB-btnDefault SB-btnMedium SB-btnEditAccountInfo"
                    style={{ display: "none" }}
                  >
                    Edit Account Info
                  </button>
                </a>
              </div>
              <div className="SB-myAccount-logout-container">
                <button
                  className="btn SB-btnQuaternary active SB-btnMedium SB-btnLogout"
                  onClick={logout}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default SideMenuBar;
